import './ApplicationForm.css';

import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { cloneDeep } from 'lodash';
import React, { useCallback, useState } from 'react'
import { Badge, Button, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { setApplication } from '../../slices/designerSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select, Badge as AntBadge, Flex } from 'antd';
import { useParams } from 'react-router-dom';
import { BdaApplication } from '../../models/BdaApplication';
import { RootState } from '../../store';
import { sectionLabelsSelector } from '../../slices/sectionsSlice';


type Props = {
  onApplicationSubmit: (application: BdaApplication) => void;
  onShowNotes?: VoidFunction;
  fromTemplate?: boolean;
}

export default function ApplicationForm({ onApplicationSubmit, fromTemplate, onShowNotes }: Props) {
  const { id } = useParams();
  const [validated, setValidated] = useState(false);
  const application = useSelector((state: RootState) => state.designer.application);
  const dispatch = useDispatch();

  const applicationLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "applications"));

  const handleFieldChange = (field: keyof BdaApplication) => (evt: any) => {
    const value = field === "tags" ? evt : evt.target.value;
    const updatedApp = cloneDeep(application);
    updatedApp[field] = value;
    dispatch(setApplication(updatedApp));
  }

  const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.preventDefault();
    evt.stopPropagation();
    setValidated(true);

    if (form.checkValidity() === true) {
      onApplicationSubmit(application);
    }
  }

  const handleShowNotes = useCallback(() => onShowNotes?.(), [onShowNotes]);

  return (
    <>
      <Form className="application-form" noValidate validated={validated} onSubmit={handleSubmit}>
        <div className="form-body">
          <Form.Group className="mb-3" controlId="bda-app-name">
            <Form.Label>Name</Form.Label>
            <Form.Control required size="sm" placeholder={`${applicationLabels.singular} Name`} value={application.name} onChange={handleFieldChange('name')} />
            <Form.Control.Feedback type="invalid">{applicationLabels.singular} Name is required.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="bda-app-description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              size="sm"
              placeholder={`${applicationLabels.singular} Description`}
              value={application.description}
              onChange={handleFieldChange('description')} />
          </Form.Group>

          <Form.Group className="mb-3" controlId="bda-app-tags">
            <Form.Label>Tags</Form.Label>
            <Select mode="tags" className="w-100" placeholder={`${applicationLabels.singular} Tags`} value={application.tags} onChange={handleFieldChange('tags')} />
          </Form.Group>

          <Flex justify="center">
            <AntBadge className="w-75" count={(application.notes || []).length}>
              <Button variant="light" className="border w-100 mb-3" size="sm" onClick={handleShowNotes}>
                <FontAwesomeIcon icon={solid("comment")} />
                <span className="ms-2">Notes</span>
              </Button>
            </AntBadge>
          </Flex>

          <Form.Group className="d-flex align-items-center justify-content-between mb-3">
            <Form.Label>Access Level</Form.Label>
            <Badge>{application.accessLevel}</Badge>
          </Form.Group>
        </div>

        <div className="form-footer">
          <button type="submit">
            <FontAwesomeIcon icon={regular('check-circle')} />
            <span className="ms-2">{fromTemplate || !id ? 'Create' : 'Edit'} {applicationLabels.singular}</span>
          </button>
        </div>
      </Form>
    </>
  )
}
